module.exports = BrowserFS.BFSRequire('buffer').Buffer;



//////////////////
// WEBPACK FOOTER
// ./~/browserfs/dist/shims/bufferGlobal.js
// module id = 5
// module chunks = 0